import { Link } from "react-router-dom";

import { Button, EmptyState } from "@/components/ui";

/**
 * SEC-GATES-02: the one state a clinic user sees when a page or section is
 * outside their role, whether the menu grants said so or the API answered 403.
 */
export function NoPermissionState({ subject }: { subject?: string }) {
  return (
    <div role="alert">
      <EmptyState
        title={subject ? `Você não tem permissão para acessar ${subject}.` : "Você não tem permissão para acessar esta página."}
        description="Peça a um administrador da clínica para liberar o acesso em Configurações › Equipe e acessos."
        action={
          <Button variant="secondary" asChild>
            <Link to="/">Voltar ao início</Link>
          </Button>
        }
      />
    </div>
  );
}
